<template>
  <a-layout class="rank">
    <a-layout-header>
      <page-nav></page-nav>
    </a-layout-header>
    <a-layout-content>
      <div class="rank-body">
        <a-breadcrumb>
          <a-breadcrumb-item>{{ $t('rank.site_name') }}</a-breadcrumb-item>
          <a-breadcrumb-item>{{ $t('nav.market_quotes') }}</a-breadcrumb-item>
          <a-breadcrumb-item>{{ $t('rank.hot_cryptocurrency') }}</a-breadcrumb-item>
        </a-breadcrumb>
        <p class="title">{{ $t('rank.hot_cryptocurrency') }}</p>
        <div class="tab-box">
          <div class="tabs">
            <div class="item"
                 :class="{'active': tabIndex == index}"
                 v-for="(item,index) in tabOptions" :key="index"
                 @click="switchTab(index)">
              <span>{{ $t(item) }}</span>
            </div>
          </div>
          <div class="select-box">
            <a-dropdown :render-to-body="false" @select="priceVal = $event">
              <div class="down-button">
                <span>{{ $t(priceVal) }}</span>
                <icon-down class="color-black"/>
              </div>
              <template #content>
                <a-doption :value="item"
                           :class="{'doption-active': priceVal == item}"
                           v-for="(item,index) in priceGroup">
                  {{ $t(item) }}
                </a-doption>
              </template>
            </a-dropdown>
            <a-dropdown :render-to-body="false" @select="marketVal = $event">
              <div class="down-button">
                <span>{{ $t(marketVal) }}</span>
                <icon-down class="color-black"/>
              </div>
              <template #content>
                <a-doption :value="item"
                           :class="{'doption-active': marketVal == item}"
                           v-for="(item,index) in market">
                  {{ $t(item) }}
                </a-doption>
              </template>
            </a-dropdown>
            <a-dropdown :render-to-body="false" @select="increaseVal = $event">
              <div class="down-button">
                <span>{{ $t(increaseVal) }}</span>
                <icon-down class="color-black"/>
              </div>
              <template #content>
                <a-doption :value="item"
                           :class="{'doption-active': increaseVal == item}"
                           v-for="(item,index) in increase">
                  {{ $t(item) }}
                </a-doption>
              </template>
            </a-dropdown>
          </div>
        </div>
        <div class="table">
          <div class="table-head">
            <div class="item">
              <span>#</span>
            </div>
            <div class="item">
              <span>{{ $t('rank.name') }}</span>
            </div>
            <div class="item">
              <span class="cursor" @click="priceSort">
                {{ $t('rank.latest_price') }}
                 <svg t="1702287193329" class="icon" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="5195" width="18" height="18">
                  <path
                      d="M512 938.688a42.624 42.624 0 0 1-35.072-18.432l-192-277.312A42.56 42.56 0 0 1 320 576h384a42.752 42.752 0 0 1 35.072 66.944l-192 277.312A42.688 42.688 0 0 1 512 938.688z"
                      :fill="pricesort == 1 || pricesort == 2 ? 'var(--border-strength-200)' : 'var(--content-primary)'" p-id="5196" data-spm-anchor-id="a313x.search_index.0.i2.72f13a81y4MtV6"
                      class="selected">
                  </path>
                  <path
                      d="M704 448H320a42.752 42.752 0 0 1-35.072-66.944l192-277.312c16-23.04 54.208-23.04 70.144 0l192 277.312A42.624 42.624 0 0 1 704 448z"
                      :fill="pricesort == 1 || pricesort == 3 ? 'var(--border-strength-200)' : 'var(--content-primary)'" p-id="5197" data-spm-anchor-id="a313x.search_index.0.i1.72f13a81y4MtV6"
                      class="selected">
                  </path>
                </svg>
              </span>
            </div>
            <div class="item">
              <span class="cursor">
                {{ $t('rank.change_today') }}
                <svg t="1702287193329" class="icon" viewBox="0 0 1024 1024" version="1.1"
                     xmlns="http://www.w3.org/2000/svg" p-id="5195" width="18" height="18">
                  <path
                      d="M512 938.688a42.624 42.624 0 0 1-35.072-18.432l-192-277.312A42.56 42.56 0 0 1 320 576h384a42.752 42.752 0 0 1 35.072 66.944l-192 277.312A42.688 42.688 0 0 1 512 938.688z"
                      :fill="pricesort == 1 || pricesort == 2 ? 'var(--border-strength-200)' : 'var(--content-primary)'" p-id="5196" data-spm-anchor-id="a313x.search_index.0.i2.72f13a81y4MtV6"
                      class="selected">
                  </path>
                  <path
                      d="M704 448H320a42.752 42.752 0 0 1-35.072-66.944l192-277.312c16-23.04 54.208-23.04 70.144 0l192 277.312A42.624 42.624 0 0 1 704 448z"
                      :fill="pricesort == 1 || pricesort == 3 ? 'var(--border-strength-200)' : 'var(--content-primary)'" p-id="5197" data-spm-anchor-id="a313x.search_index.0.i1.72f13a81y4MtV6"
                      class="selected">
                  </path>
                </svg>
              </span>
            </div>
            <div class="item">
              <span class="cursor">
                {{ $t('rank.twenty_four_hour_volume') }}
               <svg t="1702287193329" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="5195" width="18" height="18">
                  <path
                      d="M512 938.688a42.624 42.624 0 0 1-35.072-18.432l-192-277.312A42.56 42.56 0 0 1 320 576h384a42.752 42.752 0 0 1 35.072 66.944l-192 277.312A42.688 42.688 0 0 1 512 938.688z"
                      :fill="pricesort == 1 || pricesort == 2 ? 'var(--border-strength-200)' : 'var(--content-primary)'" p-id="5196" data-spm-anchor-id="a313x.search_index.0.i2.72f13a81y4MtV6"
                      class="selected">
                  </path>
                  <path
                      d="M704 448H320a42.752 42.752 0 0 1-35.072-66.944l192-277.312c16-23.04 54.208-23.04 70.144 0l192 277.312A42.624 42.624 0 0 1 704 448z"
                      :fill="pricesort == 1 || pricesort == 3 ? 'var(--border-strength-200)' : 'var(--content-primary)'" p-id="5197" data-spm-anchor-id="a313x.search_index.0.i1.72f13a81y4MtV6"
                      class="selected">
                  </path>
                </svg>
              </span>
            </div>
            <div class="item">
              <span>{{ $t('rank.operation') }}</span>
            </div>
          </div>
          <div class="table-container">
            <div v-if="currencyList.length === 0" class="loading-container" style="text-align: center; padding: 40px;">
              <div style="font-size: 16px; margin-bottom: 10px;">📊 {{ $t('rank.loading') }}</div>
              <div style="font-size: 12px; color: #999;">{{ $t('rank.please_wait') }}</div>
            </div>
            <div class="table-cell" v-for="(item, index) in currencyList" :key="item.id || index">
              <div class="item">
                <span>{{ index + 1 }}</span>
              </div>
              <div class="item">
                <img :src="item.icon || '/favicon.ico'" :alt="item.symbol" style="width: 24px; height: 24px; margin-right: 8px;">
                <span>
                  {{ item.symbol || 'N/A' }}
                  <span>/ USDT</span>
                </span>
              </div>
              <div class="item">
                <span>${{ item.new_price ? $util.thousandSeparator(item.new_price, item.decimals || 4) : '0.0000' }}</span>
              </div>
              <div class="item">
                <span :class="{'color-green': item.change_rate > 0, 'color-red': item.change_rate <= 0}">
                  {{ item.change_rate ? (item.change_rate > 0 ? '+' : '') + $util.thousandSeparator(item.change_rate, 2) + '%' : '0.00%' }}
                </span>
              </div>
              <div class="item">
                <span>{{ item.quota ? $util.bigNumberToString(item.quota) : '0' }}</span>
              </div>
              <div class="item">
                <span class="trade-button" style="color: #1890ff; cursor: pointer;" @click="goToTrade(item)">{{ $t('rank.trade') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="pagination">
          <a-pagination :total="50"/>
        </div>
      </div>
    </a-layout-content>
    <a-layout-footer>
      <Footer></Footer>
    </a-layout-footer>
  </a-layout>
</template>
<script>
import service from "./service"

export default service;
</script>
<style lang="scss" scoped>
@import "rank";
</style>